module.exports = __webpack_public_path__ + "static/media/gear-solid.5d989df9.svg";